import React, { Component } from 'react';
import moment from 'moment';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { TOOLTIP_DATE_FORMAT } from '../../constants';

export default class DatetimeTableCell extends Component {
  getTooltip() {
    return (
      <Tooltip id="tooltip">
        {moment(this.props.date).format(TOOLTIP_DATE_FORMAT)}
      </Tooltip>
    );
  }

  render() {
    const dateMoment = moment(this.props.date);

    if (!dateMoment.isValid()) {
      return (
        <td className="datetime-table-cell">
          {this.props.date}
        </td>
      );
    }

    return (
      <td className="datetime-table-cell">
        <OverlayTrigger
          placement="top"
          overlay={this.getTooltip()}
          trigger={['hover', 'focus', 'click']}
        >
          <time dateTime={dateMoment.toISOString()}>
            {dateMoment.format(this.props.displayFormat || 'HH:mm')}
          </time>
        </OverlayTrigger>
      </td>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DatetimeTableCell/DatetimeTableCell.js